import { useRef, useCallback, useEffect } from 'react';
import ddt from '@wix/da-ddt';
import { useBiLogger } from './useBiLogger';
import { isPlainClick, getClickType, MouseButton, } from '../../utils/clickHelpers';
var logger = ddt.createLogger('bilogger');
var isUsingBeacon = typeof navigator !== 'undefined' &&
    typeof navigator.sendBeacon === 'function';
function preventClick(node) {
    var handler = function (e) {
        e.preventDefault();
        node.removeEventListener('click', handler);
    };
    node.addEventListener('click', handler);
}
function isLinkClicked(e) {
    var target = e.target;
    if (!target) {
        return false;
    }
    return target.tagName.toLowerCase() === 'a' || target.closest('a');
}
function holdClick(promise, e, trackedElement, href) {
    if (isPlainClick(e) && !e.defaultPrevented) {
        e.preventDefault();
        preventClick(trackedElement);
        var target_1 = e.target;
        promise.finally(function () {
            if (href) {
                window.location.href = href;
            }
            else if (target_1 && isLinkClicked(e)) {
                target_1.dispatchEvent(new MouseEvent('click', {
                    bubbles: e.bubbles,
                    cancelable: e.cancelable,
                }));
            }
        });
    }
}
/** Returns true if the click event is trusted and used the middle or primary/left button */
export function isLoggableClickEvent(event) {
    return (event.isTrusted &&
        [MouseButton.Main, MouseButton.Auxiliary].includes(getClickType(event)));
}
export function useBiClickLogger(biData) {
    var logEvent = useBiLogger();
    var trackingRef = useRef();
    var setTrackingRef = useCallback(function (node) {
        trackingRef.current = node || undefined;
    }, []);
    useEffect(function () {
        if (!biData) {
            return;
        }
        var trackedElement = trackingRef.current;
        if (!trackedElement) {
            if (process.env.NODE_ENV !== 'production') {
                logger.error('BiLogger childNode ref has not been set up');
            }
            return;
        }
        var eventHandler = function (e) {
            // only allow left/mid clicks logging
            if (!isLoggableClickEvent(e)) {
                return true;
            }
            var wait = logEvent(biData);
            // if no bacon - cancel event, wait for logging to finish, then re-fire
            if (!isUsingBeacon) {
                holdClick(wait, e, trackedElement, biData.href);
            }
        };
        // add handler on capture, 3th param true, to catch events even if children use stopPropagation
        // mousedown to be able handle mouse middle click
        trackedElement.addEventListener('mousedown', eventHandler, true);
        return function () {
            return trackedElement.removeEventListener('mousedown', eventHandler, true);
        };
    }, [biData, logEvent]);
    return {
        setTrackingRef: setTrackingRef,
    };
}
//# sourceMappingURL=useBiClickLogger.js.map